import { iQCResult } from "@sdk/agent-quality-control/qc-results.models";
import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const QCResultDetailModal = React.lazy(() => import("./qc-result-detail.modal"));

const QCResultDetail: iModalProps<
  typeof QCResultDetailModal,
  {
    qcResult: iQCResult;
  }
> = {
  name: "qc-result-detail",
  component: GenerateModalWithSuspense(QCResultDetailModal),
};

export default QCResultDetail;
